import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import { ProjectViewComponent }   from './project-view/project-view.component';
import { DefaultPageViewComponent } from './default-page-view/default-page-view.component';
import { GridViewComponent } from './grid-view/grid-view.component';
import { ThreeColViewComponent } from './three-col-view/three-col-view.component';
import { ImageGalleryViewComponent } from './image-gallery-view/image-gallery-view.component';
import { ViewWithNavBarComponent } from './view-with-nav-bar/view-with-nav-bar.component';
import { PageComponent } from './page/page.component';

import { forEach, find, isUndefined, concat } from 'lodash';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class RoutingService {
  routes: any[];

  constructor(
    private http: Http,
    private router: Router
  ) { }

  addRoute(routes, path, component) {
    routes.splice(routes.length - 1, 0, {
      path: path,
      component: ViewWithNavBarComponent,
      children: [
        { path: '', component: component }
      ]
    });
  }

  addRedirects(routes, menuItems) {
    forEach(menuItems, (item: any) => {
      let autoselectedChild: any = find(item.children, {'autoselect': 1});
      if (item.children.length > 0 && item.page_id === 0 && isUndefined(autoselectedChild)) {
        autoselectedChild = item.children[0];
      } 
      if (!isUndefined(autoselectedChild)) {
        routes.splice(routes.length - 1, 0, {
          path: item.slug,
          redirectTo: `${item.slug}/${autoselectedChild.slug}`,
          pathMatch: 'full'
        });
      }
    });
  }

  resetRouterConfig(menus): Promise<any> {
    return new Promise((resolve, reject) => {
      let routes = [];
      let menuItems = menus[0].concat(menus[1]);
      
      forEach(menuItems, (menuItem) => {
        if (typeof menuItem.page_type !== 'undefined' && menuItem.page_type === 'column') {
          this.addRoute(routes, menuItem.slug + '/:section', PageComponent);
        }
      });

      this.addRedirects(routes, menuItems);
      
      let newConfig = concat(routes, this.router.config)
      this.router.config = newConfig;
      // Reset the config using a newly created route config
      this.router.resetConfig(this.router.config);

      resolve();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/routing.service.ts